import '../styles/navbar.css';
import { translations } from '../utils/data';
import { setToLS, getFromLS } from '../utils/storage';
import { useState, useEffect } from 'react';

export default function Navbar(props) {
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    const saved = getFromLS('language');
    if (saved !== undefined) {
      setLanguage(saved);
      props.setNumber && props.setNumber(saved === 'es' ? 1 : 0);
    } else {
      setLanguage('es');
      props.setNumber && props.setNumber(1);
    }
  }, []);

  const handleLangChange = (evt) => {
    const locale = evt.target.value;
    setLanguage(locale);
    setToLS('language', locale);
    props.setNumber && props.setNumber(locale === 'es' ? 1 : 0);
  };

  /* Nav links follow the new section order in App.js:
     1 Dirigido  2 Diagram  3 Funcionalidades  4 Mision  5 Experiencia  6 FAQ */
  const navLinks = [
    { href: '#Dirigido',        label: props.t('header_1') },
    { href: '#Diagram',         label: props.t('header_2') },
    { href: '#Funcionalidades', label: props.t('header_3') },
    { href: '#Mision',          label: props.t('header_4') },
    { href: '#Experiencia',     label: props.t('header_5') },
    { href: 'https://solutions.shelf-e.com/fqa', label: props.t('header_6') },
    { href: '#Nuestros',        label: props.t('header_7') },
  ];

  return (
    <header className="shelfe-navbar" id="home">
      <div className="navbar-inner">

        {/* Logo */}
        <a href="#" className="navbar-logo">
          <img
            width={130} height={56}
            alt="Shelf-e"
            src="images/logo_bk_drk.png"
          />
        </a>

        {/* Desktop nav links */}
        <nav className="navbar-links" aria-label="Main navigation">
          <ul>
            {navLinks.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Right controls: Login + Language */}
        <div className="navbar-controls">
          <a
            href="https://solutions.shelf-e.com/"
            className="navbar-login-btn"
          >
            {props.t('button_2')}
          </a>

          <div className="navbar-lang">
            <select
              aria-label="Language"
              value={language}
              onChange={handleLangChange}
            >
              {translations.map(({ locale }, i) => (
                <option value={locale} key={i}>
                  {locale === 'en' ? 'EN' : 'ES'}
                </option>
              ))}
            </select>
            <span className="navbar-lang-icon">🌐</span>
          </div>
        </div>

        {/* Mobile hamburger */}
        <button
          className="navbar-hamburger"
          aria-label="Abrir menú"
          onClick={() => document.getElementById('navbar-mobile-menu').classList.toggle('open')}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className="navbar-mobile-menu" id="navbar-mobile-menu">
        <ul>
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                onClick={() => document.getElementById('navbar-mobile-menu').classList.remove('open')}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="navbar-mobile-controls">
          <a href="https://solutions.shelf-e.com/" className="navbar-login-btn">
            {props.t('button_2')}
          </a>
          <select
            aria-label="Language"
            value={language}
            onChange={handleLangChange}
            className="navbar-mobile-lang"
          >
            {translations.map(({ locale }, i) => (
              <option value={locale} key={i}>
                {locale === 'en' ? 'EN' : 'ES'}
              </option>
            ))}
          </select>
        </div>
      </div>
    </header>
  );
}
